<template>
  <a
    class="language-list-card"
    :href="itemUrl"
  >
    <span
      class="language-list-card-label"
      :lang="item.regionalIsoCode"
      v-html="parsedLanguageLabel ? parsedLanguageLabel : item.displayName"
    />
  </a>
</template>

<script>
  import { ensure } from '@utils/api-helpers'
  import { highlightMatch } from '@utils/highlight-match'

  export default {
    name: 'LanguageSwitcherCard',
    props: {
      item: {
        type: Object
      },
      searchInput: {
        type: String,
        default: ''
      },
      queryChanged: {
        type: Number,
        default: -1
      },
    },
    data: () => ({
      searchString: ''
    }),
    computed: {
      itemUrl() {
        let urlWithStartSlash = this.item.url

        if (!/^https?:\/\//.test(this.item.url) && !/^\/\//.test(this.item.url)) {
          urlWithStartSlash = ensure(this.item.url, 'start', 'with')
        }

        const formattedUrl = ensure(urlWithStartSlash, 'end', 'without')
        const routeHash = this.$route ? `/#${ensure(this.$route.fullPath)}` : ''

        return formattedUrl + routeHash
      },
      parsedLanguageLabel: {
        get() {
          return highlightMatch(this.searchString, this.item.displayName, 'bold-highlighted')
        },
        set(newValue) {
          this.searchString = newValue
        }
      }
    },
    watch: {
      searchInput(val) {
        if (val) {
          this.searchString = val
        } else {
          this.searchString = ''
        }
      },
      async queryChanged() {
        this.searchString = this.searchInput
      }
    },
    methods: {
      destinationSelected(item) {
        this.$emit('destination-selected', item)
      }
    }
  }
</script>
